import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ExploreIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/explore.svg" alt="" />
  );
};

export default ExploreIcon;
